import { makeStyles } from "@material-ui/core";
import { MdKeyboardBackspace } from "react-icons/md";
import { COLORS } from "../assets/theme";
import { useNavigate } from "react-router-dom";
import { ROUTES, combinedRoutes } from "../config/nav";
import useRoleUser from "../hooks/auth/useRoleUser";
import React from "react";
import { Html5QrcodeResult } from "html5-qrcode";
import Html5QrcodePlugin from "../components/qrcode/Html5QrCodePlugin";
type Props = {};

const useStyles = makeStyles(() => {
  return {
    container: {
      height: "100vh",
      backgroundColor: "#090e11",
      position: "relative",
    },
    qrCodeContainer: {
      display: "flex",
      justifyContent: "center",
      flexDirection: "column",
      position: "relative",
      height: "100%",
    },
    backButton: {
      position: "absolute",
      top: 0,
      left: 4,
      zIndex: 9,
    },
    qrCodeViewFinder: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      zIndex: 99,
    },
    qrCodeBox: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },
  };
});

const QrCodeScannerPage = (_: Props) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const role = useRoleUser();
  const handleNavigate = React.useCallback(
    (text: string) => {
      switch (role) {
        case "GUEST":
          navigate(`${combinedRoutes.guest_vehicle_detail}/${text}`);
          break;
        case "FSO":
          navigate(`${combinedRoutes.vehicle_detail}/${text}`);
          break;
        default:
          break;
      }
    },
    [role]
  );

  // const onNewScanResult: OnResultFunction = (result) => {
  //   if (result?.getText()) {
  //     handleNavigate(result.getText());
  //   }
  // };

  const onNewScanResult = (decodedText: string, _: Html5QrcodeResult) => {
    // handle decoded results here
    handleNavigate(decodedText);
  };

  return (
    <div className={classes.container}>
      <MdKeyboardBackspace
        color={COLORS.white}
        size={36}
        className={classes.backButton}
        style={{ margin: 12 }}
        onClick={() => {
          navigate(`${role && role === "FSO" ? ROUTES.admin : ROUTES.guest}`);
        }}
      />
      <div className={classes.qrCodeContainer}>
        <Html5QrcodePlugin
          fps={20}
          qrbox={200}
          aspectRatio={4 / 5}
          qrCodeSuccessCallback={onNewScanResult}
        />
        {/* <QrReader
          constraints={{ facingMode: "environment" }}
          onResult={onNewScanResult}
          ViewFinder={Viewfinder}
        /> */}
      </div>
    </div>
  );
};

export default QrCodeScannerPage;
